module.exports = __webpack_public_path__ + "img/gww_02.3c2e30e2.jpg";